import { axiosPost } from "./service";

export const userAuthenticationService = (callback) => {
    axiosPost("user/user-auth", {}, callback, true);
}

export const setUserDefaultAccountService = ({ defaultAccountId }, callback) => {
    axiosPost("user/default-account", { account_id: defaultAccountId }, callback, true);
}
